import { render, staticRenderFns } from "./PT470ProductSearchDetailsParts.vue?vue&type=template&id=dd24ac2c&"
import script from "./PT470ProductSearchDetailsParts.vue?vue&type=script&lang=js&"
export * from "./PT470ProductSearchDetailsParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports